export const urls = {
  VARATI_KATEGORIJE: 'KategorijeDelova/vrati_kategorije_delova',
  DELETE_KATEGORIJA: 'KategorijeDelova/brisanje_kategorije_delova',
  INSERT_KATEGORIJE: 'KategorijeDelova/unos_kategorije_delova',
  UPDATE_KATEGORIJE: 'KategorijeDelova/izmena_kategorije_delova',
};
